import { api } from './postMessage.js';

function handler(payload, e) {
  api.turnOff();
}
api.addHandler('turnOff', handler);
